import type { PortalClienteState } from '@/types/portalClienteState'
import { computeNpsStats } from '@/utils/portalClienteUtils'
import { PortalClienteHeader } from '@/components/PortalCliente/PortalClienteHeader'
import { PortalClienteDealSection } from '@/components/PortalCliente/PortalClienteDealSection'
import { PortalClienteHealthSection } from '@/components/PortalCliente/PortalClienteHealthSection'
import { PortalClienteCheckinSection } from '@/components/PortalCliente/PortalClienteCheckinSection'
import { PortalClienteNpsSection } from '@/components/PortalCliente/PortalClienteNpsSection'
import { PortalClienteTimelineSection } from '@/components/PortalCliente/PortalClienteTimelineSection'
import { PortalClienteSupportSection } from '@/components/PortalCliente/PortalClienteSupportSection'

export function PortalClienteContent({ portal }: { portal: PortalClienteState }) {
  const { data } = portal
  if (!data) return null

  const npsStats = computeNpsStats(data.nps.map((n) => n.score))

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      <PortalClienteHeader data={data} />
      <main className="max-w-4xl mx-auto px-4 py-6 space-y-6">
        <PortalClienteDealSection data={data} />
        <PortalClienteHealthSection data={data} npsStats={npsStats} />
        <PortalClienteCheckinSection data={data} portal={portal} />
        <PortalClienteNpsSection data={data} portal={portal} npsStats={npsStats} />
        <PortalClienteTimelineSection data={data} />
        <PortalClienteSupportSection data={data} />
        <footer className="text-center py-6 text-xs text-white/20">
          Portal do Cliente &middot; Acesso seguro via token
        </footer>
      </main>
    </div>
  )
}
